import { useCurrentPatientId } from '@/modules/surgicalEvent';
import { useUpdateScoreMutation } from './medicalScore.slice';
import { MedicalScore } from './model';

export const useCurrentUpdateScore = () => {
  const currentParams = useCurrentPatientId();
  const [updateScore, ...mutationProps] = useUpdateScoreMutation();

  async function handleMutation<S extends MedicalScore>(
    score: Partial<S>,
    finalize = false
  ): Promise<{ data: S }> {
    return updateScore({
      ...currentParams,
      score,
      finalize
    }).unwrap() as unknown as Promise<{ data: S }>;
  }

  return [handleMutation, ...mutationProps] as const;
};
